import React from 'react';
import { takeLatest, put, call } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';

import newsletter from '../../api/newsletter';
import {
  NEWSLETTER_BASE_TEMPLATE_GET,
  NEWSLETTER_DELETE,
  NEWSLETTER_DETAILS_GET,
  NEWSLETTER_GET,
  NEWSLETTER_READ,
  NEWSLETTER_SEND,
} from '../actions/newsletter';
import { ToastSuccess } from '../../../ui/components/Toast';

function* getNewsletter({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data, pager } = {} } = yield call(
      newsletter.getNewsletter,
      {
        ...filters,
      }
    );
    yield put({ type: NEWSLETTER_GET._SUCCESS, data, pager });
  } catch (error) {
    yield put({ type: NEWSLETTER_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > newsletter > getNewsletter', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsletterGetWatch() {
  yield takeLatest(NEWSLETTER_GET._REQUEST, getNewsletter);
}

function* newsletterRead({ ids, status, filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const params = {
      newsletter_ids: ids,
      newsletter_status: status,
    };
    yield call(newsletter.newsletterRead, params);
    yield put({ type: NEWSLETTER_READ._SUCCESS });
    yield put({ type: NEWSLETTER_GET._REQUEST, filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > newsletter > newsletterRead', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsletterReadWatch() {
  yield takeLatest(NEWSLETTER_READ._REQUEST, newsletterRead);
}

function* newsletterDelete({ ids, filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const params = {
      newsletter_ids: ids,
    };
    yield call(newsletter.newsletterDelete, params);
    yield put({ type: NEWSLETTER_DELETE._SUCCESS });
    yield put({ type: NEWSLETTER_GET._REQUEST, filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > newsletter > newsletterDelete', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsletterDeleteWatch() {
  yield takeLatest(NEWSLETTER_DELETE._REQUEST, newsletterDelete);
}

function* newsletterDetailsGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data: response = {} },
    } = yield call(newsletter.newsletterDetailsGet, id);
    yield put({ type: NEWSLETTER_DETAILS_GET._SUCCESS, response });
  } catch (error) {
    yield put({ type: NEWSLETTER_DETAILS_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > newsletter > newsletterDetailsGet', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsletterDetailsGetWatch() {
  yield takeLatest(NEWSLETTER_DETAILS_GET._REQUEST, newsletterDetailsGet);
}

function* newsletterSend({ body }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      newsletter.newsletterSend,
      body
    );
    if (response?.result) {
      yield put({ type: NEWSLETTER_SEND._SUCCESS, response });
      toast.success(<ToastSuccess title="Newsletter inviata correttamente" />);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > newsletter > newsletterSend', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsletterSendWatch() {
  yield takeLatest(NEWSLETTER_SEND._REQUEST, newsletterSend);
}

function* newsletterBaseTemplateGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      newsletter.newsletterBaseTemplateGet
    );
    yield put({ type: NEWSLETTER_BASE_TEMPLATE_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > newsletter > newsletterBaseTemplateGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsletterBaseTemplateGetWatch() {
  yield takeLatest(
    NEWSLETTER_BASE_TEMPLATE_GET._REQUEST,
    newsletterBaseTemplateGet
  );
}

export default [
  newsletterGetWatch(),
  newsletterReadWatch(),
  newsletterDeleteWatch(),
  newsletterDetailsGetWatch(),
  newsletterSendWatch(),
  newsletterBaseTemplateGetWatch(),
];
